export default "__VITE_ASSET__CexEof$3__"